import { __rest } from "tslib";
import * as React from 'react';
const ChevronUpXSmall = (_a) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 16 16", fill: "currentColor", width: size || "16", height: size || "16" }, props),
        React.createElement("path", { fillRule: "evenodd", d: "M8.34816628,5.64674487 L8.35176648,5.65074487 L8.35481987,5.64787326 L9.06192665,6.35498004 L9.05976648,6.35674487 L12.3548733,9.64776648 L11.6477665,10.3548733 L8.35176648,7.06474487 L5.06187326,10.3548733 L4.35476648,9.64776648 L7.64476648,6.35774487 L7.64105949,6.35385166 L8.34816628,5.64674487 Z" })));
};
ChevronUpXSmall.displayName = 'ChevronUpXSmall';
export default ChevronUpXSmall;
//# sourceMappingURL=ChevronUpXSmall.js.map